
import { Component, Vue } from 'vue-property-decorator'
import DealDetail from '@/components/company/deal/DealDetail.vue'

@Component({
  name: 'Deal',
  components: { DealDetail }
})
class Deal extends Vue {}

export default Deal
